import logo from "../../assets/aviatricks-logo-1.png";
import { FiFacebook, FiInstagram, FiLinkedin } from "react-icons/fi";
import "./FooterCard.css";

export default function FooterCard() {
    return (
        <footer className="footer">
            <div className="footer-card">

                {/* Corner brackets */}
                <span className="footer-corner footer-corner--tl" />
                <span className="footer-corner footer-corner--tr" />
                <span className="footer-corner footer-corner--bl" />
                <span className="footer-corner footer-corner--br" />

                {/* Top purple accent bar */}
                <div className="footer-accent-bar" />

                <div className="footer-inner">

                    {/* Grid */}
                    <div className="footer-grid">

                        {/* Brand */}
                        <div className="footer-col brand">
                            <div className="footer-logo-wrap">
                                <img src={logo} alt="Aviatricks" />
                            </div>
                            <p className="brand-tagline">
                                Professional aviation and drone solutions for industry,
                                training, and enterprise operations.
                            </p>
                            <div className="brand-meta">
                                <span className="brand-meta-item">
                                    <span className="brand-meta-dot" />
                                    Manickampalayam, Koothampoondi, Tamil Nadu 637202
                                </span>
                                <span className="brand-meta-item">
                                    <span className="brand-meta-dot" />
                                    support@aviatricks.in
                                </span>
                                <span className="brand-meta-item">
                                    <span className="brand-meta-dot" />
                                    +91 9150739434
                                </span>
                            </div>
                        </div>

                        {/* Company */}
                        <div className="footer-col">
                            <p className="footer-col-heading">Company</p>
                            <a href="/" className="footer-nav-link">Home</a>
                            <a href="/about" className="footer-nav-link">About Us</a>
                            {/* <a href="/careers" className="footer-nav-link">Careers</a> */}
                            <a href="/contact/support" className="footer-nav-link">Contact</a>
                        </div>

                        {/* Products */}
                        <div className="footer-col">
                            <p className="footer-col-heading">Products</p>
                            <a href="/our-businesses/agri" className="footer-nav-link">Agri</a>
                            <a href="/our-businesses/survey" className="footer-nav-link">Survey</a>
                            <a href="/our-businesses/camera" className="footer-nav-link">Camera</a>
                            <a href="/our-businesses/overview" className="footer-nav-link">Enterprise Solutions</a>
                        </div>

                        {/* Platforms */}
                        <div className="footer-col">
                            <p className="footer-col-heading">Platforms</p>
                            <a href="/businesses/flyhub" className="footer-nav-link">Flyhub</a>
                            <a href="/businesses/airspacemap" className="footer-nav-link">AirspaceMap</a>
                            <a href="/businesses/flytutor" className="footer-nav-link">Flytutor</a>
                            {/* <a href="/businesses/solarmark" className="footer-nav-link">SolarMark</a> */}
                            <a href="/businesses/agri-sim" className="footer-nav-link">Agri Simulation</a>
                        </div>

                        {/*Legal */}
                        <div className="footer-col">
                            <p className="footer-col-heading">Legal</p>
                            <a href="/terms-and-conditions" className="footer-nav-link">Terms & Conditions</a>
                            <a href="/privacy-policy" className="footer-nav-link">Privacy Policy</a>
                        </div>

                    </div>

                    {/* Gradient divider */}
                    <div className="footer-divider" />

                    {/* Bottom row */}
                    <div className="footer-bottom">

                        <p className="footer-copy">
                            © {new Date().getFullYear()} <span>AVIATRICKS.</span> All rights reserved.
                        </p>

                        <div className="footer-status">
                            <span className="footer-status-dot" />
                            ALL SYSTEMS OPERATIONAL
                        </div>

                        <button className="footer-btn">
                            <span className="footer-btn-text">ENQUIRE NOW</span>
                            <span className="footer-btn-arrow">→</span>
                        </button>

                        <div className="footer-socials">
                            {/* <a href="https://facebook.com" className="footer-social-btn" aria-label="Facebook" target="_blank" rel="noreferrer">
                                <FiFacebook />
                            </a> */}
                            <a href="https://instagram.com" className="footer-social-btn" aria-label="Instagram" target="_blank" rel="noreferrer">
                                <FiInstagram />
                            </a>
                            <a href="https://linkedin.com" className="footer-social-btn" aria-label="LinkedIn" target="_blank" rel="noreferrer">
                                <FiLinkedin />
                            </a>
                        </div>

                    </div>
                </div>
            </div>
        </footer>
    );
}